import { render, staticRenderFns } from "./T2AutoResearcherBox.vue?vue&type=template&id=138a49ca&scoped=true"
import script from "./T2AutoResearcherBox.vue?vue&type=script&lang=js"
export * from "./T2AutoResearcherBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a49ca",
  null
  
)

export default component.exports